<template>
	<lcsj-dialog v-model="showDialog" title="消费订单记录" width="80%" @close="closeDialog" cancel-text="关闭">
		<div class="selectContent">
			<el-radio-group v-model.number="selectType" @input="handleInputChange">
				<el-radio-button :label="1">销售订单</el-radio-button>
				<el-radio-button :label="2">加工订单</el-radio-button>
			</el-radio-group>
		</div>
		<div>
			<!-- 销售订单记录 -->
			<salesOrderRecord ref="salesOrderRecord"></salesOrderRecord>
			<!-- 加工订单记录 -->
			<storeOrderRecord ref="storeOrderRecord"></storeOrderRecord>
		</div>
		
	</lcsj-dialog>
</template>

<script>
import salesOrderRecord from "@/views/product/sales/salesRecord.vue";
import storeOrderRecord from "@/views/baseData/storeOrder/order/storeOrderRecord.vue";
export default {
	data() {
		return {
			selectType: 1,
			showDialog: false,
			keyId: ""
		};
	},
	// 注册组件
	components: {
		salesOrderRecord,
		storeOrderRecord
	},
	created() {},
	computed: {},
	methods: {
		showSelectOrderDialog(keyId) {
			this.showDialog = true;
			this.selectType = 1;
			this.keyId = keyId;
			this.$nextTick(() => {
				this.handleInputChange(1);
			});
		},
		handleInputChange(val) {
			this.selectType = val;
			if (val == 1) {
				this.$refs.salesOrderRecord.showSalesOrderRecord(this.keyId);
				this.$refs.storeOrderRecord.closeMachineOrder();
			} else if (val == 2) {
				this.$refs.salesOrderRecord.closeSalesOrderRecord();
				this.$refs.storeOrderRecord.showMachineOrder(this.keyId);
			}
		},
		closeDialog() {
			this.$refs.salesOrderRecord.closeSalesOrderRecord();
			this.$refs.storeOrderRecord.closeMachineOrder();
			this.keyId = "";
			this.showDialog = false;
		}
	}
};
</script>

<style scoped>
.selectContent {
	margin-top: 20rpx;
	display: flex;
	justify-content: center;
	align-items: center;
}

.item_info {
	border-left: 5px solid var(--app-primary-hover);
	padding: 5px 10px;
	border-radius: 5px;
	margin-bottom: 15px;
	border-bottom: 2px solid var(--app-border);
}

.border_Green {
	border-left: 5px solid var(--app-success);
}
</style>
